var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmarkThin = function SvgCheckmarkThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.138 1.695 3.546 9.287.862 6.603a.325.325 0 0 0-.46 0l-.307.307a.325.325 0 0 0 0 .46l3.221 3.22a.325.325 0 0 0 .46 0l8.129-8.128a.325.325 0 0 0 0-.46l-.307-.307a.325.325 0 0 0-.46 0Z",
    fill: "currentColor"
  })));
};

export default SvgCheckmarkThin;